<template>
    <span class="badge badge-pill text-white mr-2" :class="' badge-'+type">{{ message }}</span>
</template>

<script>
export default {
    name: 'Badge',
    props: {
        message: {
            type: String,
            default: 'Aktiv',
        },
        type: {
            type: String,
            default: 'success',
        },
    },
};
</script>

<style scoped>

</style>
